"use strict";
/**
 * Created on 03 26 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var RealImpactValue_1 = require("../RealImpactValue");
/**
 * <p>Encapsulates aggregated {@link RealImpact price impact} for product level based on related {@link SelloutReleaseItem items}.</p>
 *
 * @author JMe
 */


var SelloutProductPriceImpact =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutProductPriceImpact, _DomainObject_1$Domai);

  /**
   * @param productId Identification of product, most probably {@link Product.id} will be used.
   * @param realImpact Aggregated {@link RealImpact price impact} if any.
   */
  function SelloutProductPriceImpact(productId, realImpact) {
    var _this;

    _classCallCheck(this, SelloutProductPriceImpact);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutProductPriceImpact).call(this));
    _this.productId = productId;
    _this.realImpact = realImpact;
    return _this;
  }

  return SelloutProductPriceImpact;
}(DomainObject_1.DomainObject);

exports.SelloutProductPriceImpact = SelloutProductPriceImpact;

SelloutProductPriceImpact.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutProductPriceImpact.name);
  return {
    productId: builder.str('productId'),
    realImpact: builder.opt(builder.obj('realImpact', RealImpactValue_1.RealImpactValue.schema, RealImpactValue_1.RealImpactValue.ctor))
  };
}();